/**
 * Tiny stale-while-revalidate cache for page data (localStorage).
 *
 * Pattern: pages initialize state from `readCache(key)` → render the last
 * known REAL data instantly → fetch fresh in the background → `writeCache`.
 * Keys are namespaced per user_id by callers so account switches never leak.
 */
const PREFIX = "nerdy_swr_";

export function readCache(key) {
    try {
        const raw = localStorage.getItem(PREFIX + key);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function writeCache(key, data) {
    try {
        localStorage.setItem(PREFIX + key, JSON.stringify(data));
    } catch {
        // Storage full or blocked — caching is best-effort.
    }
}

/** Sign-out hygiene: drop all cached page data + the cached user. */
export function clearAllCaches() {
    try {
        Object.keys(localStorage)
            .filter((k) => k.startsWith(PREFIX) || k === "nerdy_user")
            .forEach((k) => localStorage.removeItem(k));
    } catch {
        // ignore
    }
}
